import {pick} from 'lodash';

import {PERSISTENT_STORE_LOCAL_STORAGE_KEY, LocalStorageKeys} from '~/shared/consts/localStorageConsts';

import {resyncLatestPersistStore} from './persistStoreMiddleware';

export const clearReleventStorageData = () => {
  const currentLocalStorageValue = JSON.parse(localStorage.getItem(PERSISTENT_STORE_LOCAL_STORAGE_KEY) as string);

  const a11yLocalStorage = pick(currentLocalStorageValue, 'a11y');
  const ActiveOrderDismissedBanners = JSON.parse(
    localStorage.getItem(LocalStorageKeys.DISMISSED_ACTIVE_ORDERS) as string,
  );
  const lastOtlRedirectTimestamp = JSON.parse(
    localStorage.getItem(LocalStorageKeys.LAST_OTL_REDIRECT_TIMESTAMP) as string,
  );
  const cookieConsentTimestamp = localStorage.getItem(LocalStorageKeys.COOKIE_CONSENT_TIMESTAMP);
  localStorage.clear();

  localStorage.setItem(PERSISTENT_STORE_LOCAL_STORAGE_KEY, JSON.stringify(a11yLocalStorage));
  localStorage.setItem(LocalStorageKeys.DISMISSED_ACTIVE_ORDERS, JSON.stringify(ActiveOrderDismissedBanners));
  if (lastOtlRedirectTimestamp) {
    localStorage.setItem(LocalStorageKeys.LAST_OTL_REDIRECT_TIMESTAMP, JSON.stringify(lastOtlRedirectTimestamp));
  }
  if (cookieConsentTimestamp) {
    localStorage.setItem(LocalStorageKeys.COOKIE_CONSENT_TIMESTAMP, cookieConsentTimestamp);
  }

  // Keep the middleware's in-memory snapshot consistent with the storage we just cleared,
  // so the `pagehide`/`unload` dump during logout's hard navigation can't write the stale
  // (pre-logout) scopes back and resurrect e.g. the current address.
  resyncLatestPersistStore();
};
